'use strict';

exports.__esModule = true;

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PoweredByImage =
/*#__PURE__*/
(0, _reactEmotion2.default)('img', {
  target: 'e1eb5iy50'
})('width:110px;');
exports.default = PoweredByImage;